import { useEffect } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import MobileEmergencyBar from '../../components/MobileEmergencyBar';
import HeroSection from './components/HeroSection';
import MajorClientsSection from './components/MajorClientsSection';
import ProjectShowcase from './components/ProjectShowcase';
import CapabilitiesSection from './components/CapabilitiesSection';
import IndustryExpertiseSection from './components/IndustryExpertiseSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';

const CommercialExperience = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      
      <main className="flex-1 pt-16">
        <HeroSection />
        <MajorClientsSection />
        <ProjectShowcase />
        <CapabilitiesSection />
        <IndustryExpertiseSection />
        <TestimonialsSection />
        <CTASection />
      </main>

      <Footer />
      <MobileEmergencyBar />
    </div>
  );
};

export default CommercialExperience;